import { render, staticRenderFns } from "./PolicyInstrumentsAndIncentives.vue?vue&type=template&id=f711ebb8&scoped=true"
import script from "./PolicyInstrumentsAndIncentives.vue?vue&type=script&lang=js"
export * from "./PolicyInstrumentsAndIncentives.vue?vue&type=script&lang=js"
import style0 from "./PolicyInstrumentsAndIncentives.vue?vue&type=style&index=0&id=f711ebb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f711ebb8",
  null
  
)

export default component.exports